<div class="modal inmodal fade in email-view-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>

                <p class="subject" [attr.mail-id]="data.id">{{data.subject}}</p>

                <div class="row m-b-sm increased-text" *ngIf="!authenticationService.userIsResident">
                    <div class="col-sm-2">From:</div>
                    <div class="col-sm-10">{{data.senderName}} ({{data.sender}})</div>
                </div>

                <div class="row m-b-sm" *ngIf="!authenticationService.userIsResident">
                    <div class="col-sm-2 increased-text m-t-sm">To:</div>
                    <div class="col-sm-10">
                        <recipients-filter-view [recipientFilterState]="recipientFilterState" [inViewModal]="true"></recipients-filter-view>
                    </div>
                </div>

                <div class="row m-b-sm increased-text" *ngIf="!authenticationService.userIsResident && (data.replyToName || data.replyTo)">
                    <div class="col-sm-2">Reply To:</div>
                    <div class="col-sm-10">{{data.replyToName}} ({{data.replyTo}})</div>
                </div>

                <div class="row m-b-md increased-text">
                    <div class="col-sm-2">Sent On:</div>
                    <div class="col-sm-10">{{data.createdAt | date:"dd.MM.yyyy 'at' hh:mm a"}}</div>
                </div>

                <div class="form-group" id="summernote">{{data.message}}</div>

                <p class="attachments-title strong increased-text" *ngIf="data.attachments && data.attachments.length">Attachments</p>

                <a *ngFor="let item of data.attachments" class="attachments" (click)="showAttachment(item)">
                    <div>
                        <span class="file-name">{{item.name}}</span>
                        <span class="file-size">({{+(item.fileSize/1000).toFixed(0)}}kb)</span>
                    </div>
                    <i class="fa fa-search"></i>
                </a>

                <div *ngIf="es.account.canUpdate(es.serviceName)" class="btns-box">
                    <button class="btn btn-default-green m-t-md" (click)="createCopy()">Create a Copy</button>

                    <button class="btn btn-primary m-t-md m-l-md"
                            *ngIf="data.status === 'draft'"
                            (click)="send()"
                            [disabled]="disabledSubmit">
                        Send
                    </button>
                </div>

            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>
<spinner [spinnerShow]="es.isUploadImageSpinnerShow"></spinner>



// WEBPACK FOOTER //
// /app/src/app/views/email/email-view-modal/email-view-modal.component.html